import { render, staticRenderFns } from "./IconGoogleChevronDown.vue?vue&type=template&id=5ba14019&"
import script from "./IconGoogleChevronDown.vue?vue&type=script&lang=ts&"
export * from "./IconGoogleChevronDown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports